export default __webpack_public_path__ + "static/media/info.070cac9a.jpg";